import React from 'react'
import { connect } from 'react-redux'
import stylesPc from '../styles/elapsedTimeStyle.js'
import stylesPhone from '../styles/elapsedTimeStyleSmartPhone.js'

var styles;

type Props = {
    getMeetingTime: Function;
    isStart: Boolean;
    startTime: Date;
};

type State = {
    hour: String;
    min: String;
    sec: String;
};

// 初期化
var mHour = 0;
var mMin = 0;
var mSec = 0;
var now = 0;
var totalSec = 0;
var timeOut;
class ElapsedTime extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.containerDiv = React.createRef();
        this.state = {
            hour: "00",
            min: "00",
            sec: "00",
        };
    }

    shouldComponentUpdate(nextProps: Object) {
        return this.props.isStart === nextProps.isStart;
    }

    disp(isStart): Function {
        if (isStart) {
            now = new Date();
            totalSec = parseInt((now.getTime() - this.props.startTime.getTime()) / 1000);
            this.props.getMeetingTime(totalSec - 1);
            mHour = parseInt(totalSec / 3600);
            mMin = parseInt((totalSec / 60) % 60);
            mSec = totalSec % 60;

            // 数値が1桁の場合、頭に0を付けて2桁で表示する指定
            if (mHour < 10) { mHour = "0" + mHour; }
            if (mMin < 10) { mMin = "0" + mMin; }
            if (mSec < 10) { mSec = "0" + mSec; }
            this.setState({
                hour: mHour,
                min: mMin,
                sec: mSec
            })
        } else {
            clearTimeout(timeOut);
            this.setState({
                hour: "00",
                min: "00",
                sec: "00"
            });
        }
    }

    render() {
        styles = this.props.screenwidth > 400 * 2 ? stylesPc : stylesPhone;
        timeOut = setTimeout(() => this.disp(this.props.isStart), 1000);
        return (
            <div style={styles.main}>
                {this.state.hour + ':' + this.state.min + ':' + this.state.sec}
            </div>
        );
    }
}

ElapsedTime.defaultProps = {
    isStart: false,
}
const mapStateToProps = state => ({
    screenwidth: state.app.screenWidth,
});

export default connect(mapStateToProps)(ElapsedTime);